export default "__VITE_ASSET__DnuIuneb__"